import { AxiosInstance, isAxiosError } from 'axios'
import { Solicitacao } from './solicitacao'
import { CodigoBarraAvulso } from './codigo-barra-avulso'

export class CertidaoNegativaRepository {
    constructor(
        private api: AxiosInstance
    ) { }

    async getSolicitacoes(codigo_unidade: number): Promise<Solicitacao[]> {
        try {
            let { data } = await this.api.get<Solicitacao[]>(`/certidao-negativa/solicitacoes`, {
                params: {
                    codigo_unidade
                }
            })
            return data
        } catch (error) {
            return []
        }
    }

    async solicitar(codigo_unidade: number): Promise<Solicitacao> {
        try {
            let { data } = await this.api.post<Solicitacao>(`/certidao-negativa/solicitacoes`, {
                codigo_unidade
            })
            return data
        } catch (error) {
            let message = "Não foi possível solicitar a certidão negativa"
            if (isAxiosError(error)) {
                message = error.response?.data?.error
            } else if (error instanceof Error) {
                message = error.message
            }

            throw new Error(message)
        }

    }
    async sendBoletoPorEmail(codigo_boleto: number): Promise<void> {
        try {
            await this.api.post<void>(`/certidao-negativa/send-boleto-por-email`, {
                codigo_boleto
            })
            return
        } catch (error) {
            let message = "Não foi possível enviar o boleto"
            if (isAxiosError(error)) {
                message = error.response?.data?.error
            } else if (error instanceof Error) {
                message = error.message
            }

            throw new Error(message)
        }

    }
    async qrcode(codigo_boleto: number): Promise <string> {
        try {
            let { data } = await this.api.get<{ qrcode: string }>(`/certidao-negativa/qr-code`, {
                params: {
                    codigo_boleto
                }
            })
            return data.qrcode
        } catch (error) {
            let message = "Não foi possível gerar o QRCode"
            if (isAxiosError(error)) {
                message = error.response?.data?.error
            } else if (error instanceof Error) {
                message = error.message
            }

            throw new Error(message)
        }
    }
    async codigoBarras(codigo_boleto: number): Promise <CodigoBarraAvulso> {
        try {
            let { data } = await this.api.get<CodigoBarraAvulso>(`/certidao-negativa/codigo-barras`, {
                params: {
                    codigo_boleto
                }
            })
            return data
        } catch (error) {
            let message = "Não foi possível gerar o código de barras"
            if (isAxiosError(error)) {
                message = error.response?.data?.error
            } else if (error instanceof Error) {
                message = error.message
            }

            throw new Error(message)
        }
    }
}